export const Delivery = ({
  className,
  isFastDelivery,
  DELIVERY,
  translated
}) => {
  return `
<div class="${
    isFastDelivery
      ? className.DETAILS.DELIVERY.FAST
      : className.DETAILS.DELIVERY.NORMAL
  }">
    ${DELIVERY}: ${translated}
</div>
  `;
};

export default Delivery;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/Details/delivery.js
 **/